import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../../console/store/useAuthStore";
import useToastStore from "../../../../../console/store/useToastStore";
import { enum_api_uri } from "../../../utils/enum";

interface PostCategoryRequest {
    category_name: string;
    wreath_option: boolean;
    union_option: boolean;
    category_image?: File | null;
}

interface ApiResponse {
    status: string;
    message: string;
}

export const usePostGoodsCategory = (successCallback?: () => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const { addToast } = useToastStore();

    return useMutation<ApiResponse, Error, PostCategoryRequest>({
        mutationFn: async (data: PostCategoryRequest) => {
            const formData = new FormData();

            formData.append("category_name", data.category_name);
            formData.append("wreath_option", data.wreath_option.toString());
            formData.append("union_option", data.union_option.toString());

            if (data.category_image) {
                formData.append("category_image", data.category_image);
            }

            const response = await axios.post(enum_api_uri.post_product_category, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsCategory"] });
            addToast({
                message: "카테고리가 신규등록되었습니다.",
                type: "success",
            });
            successCallback?.();
        },
    });
};
